import React, { useState, useEffect, useContext } from "react";
import { Alchemy, Network } from "alchemy-sdk";
import { ethers, verifyMessage, BrowserProvider, formatEther } from "ethers";
import Swap from "../../components/Swap";
import OrderWidget from "../../components/OrderWidget";
import axios from "axios";
import BotWidget from "../../components/BotWidget";
import Header from "../../components/Header/Header";
import WalletBalance from "../../components/WalletBalance";
import TradingPair from "../../components/TradingPair";
import { WalletContext } from "../../layout/WalletContext";
import TransactionWidget from "../../components/ TransactionWidget";
import ContractBalance from "../../components/ContractBalance";
import TransferOwnership from "../../components/TransferOwnership";

const baseUrl = `${process.env.REACT_APP_API_URL}/wallet`;

const MAINNET_TOKENS = {
  "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48": "USDC",
  "0xdac17f958d2ee523a2206206994597c13d831ec7": "USDT",
  "0x6b175474e89094c44da98b954eedeac495271d0f": "DAI",
  "0x4fabb145d64652a948d72533023f6e7a623c7c53": "BUSD",
  "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2": "WETH",
  "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599": "WBTC",
  "0xb8c77482e45f1f44de1745f52c74426c631bdd52": "BNB",
  "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82": "CAKE",
  "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0": "MATIC",
  "0x3845badade8e6dff049820680d1f14bd3903a5d0": "SAND",
  "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984": "UNI",
  "0x514910771af9ca656af840dff83e8264ecf986ca": "LINK",
  "0x7d3bf5b8ee0943d92d5bc3a6cbb2da7e6ed3d4a8": "SOL",
  "0x85f138bfee4ef8e540890cfb48f620571d67eda3": "AVAX",
};

const alchemy = new Alchemy({
  apiKey: "yI8WeguNEFz6zHo1rWw30zW6nL0hGG19",
  network: Network.ETH_MAINNET,
});

let address = process.env.REACT_APP_CONTRACT_ADDRESS;

const Home = () => {
  const { walletAddress } = useContext(WalletContext);
  const [contractAddress, setContractAddress] = useState(address);
  const [contractTokens, setContractTokens] = useState([]);
  const [balance, setBalance] = useState(null);
  const [tokens, setTokens] = useState([]);

  useEffect(() => {
    if (walletAddress) {
      fetchWalletInfo(walletAddress);
    }
  }, [walletAddress]);

  useEffect(() => {
    if (contractAddress) {
      fetchContractInfo(contractAddress);
    }
  }, [contractAddress]);

  const formatTokens = async (tokenBalances) => {
    const filtered = tokenBalances.filter(
      (t) =>
        t.tokenBalance !==
          "0x0000000000000000000000000000000000000000000000000000000000000000" &&
        MAINNET_TOKENS[t.contractAddress.toLowerCase()]
    );

    const metadata = await Promise.all(
      filtered.map((token) =>
        alchemy.core.getTokenMetadata(token.contractAddress)
      )
    );
    const formatted = filtered.map((token, i) => {
      const decimals = metadata[i].decimals || 18;
      const balance = Number(token.tokenBalance) / Math.pow(10, decimals);
      return {
        symbol: metadata[i].symbol,
        name: metadata[i].name,
        balance: balance.toFixed(4),
        rawBalance: balance,
        contractAddress: token.contractAddress,
      };
    });

    // Sort descending
    return formatted
      .sort((a, b) => b.rawBalance - a.rawBalance)
      .map(({ rawBalance, ...t }) => t);
  };

  const fetchWalletInfo = async (wallet) => {
    try {
      const provider = new BrowserProvider(window.ethereum);
      const balanceWei = await provider.getBalance(wallet);
      const balanceInEth = formatEther(balanceWei);

      const tokenRes = await alchemy.core.getTokenBalances(wallet);

      const formatted = await formatTokens(tokenRes.tokenBalances);

      // Add ETH
      formatted.unshift({
        symbol: "ETH",
        name: "Ethereum",
        balance: Number(balanceInEth).toFixed(4),
      });

      setTokens(formatted);
    } catch (err) {
      console.error("Failed to fetch wallet info:", err.message);
    }
  };

  const fetchContractInfo = async (contract) => {
    try {
      const provider = new BrowserProvider(window.ethereum);
      const balanceWei = await provider.getBalance(contract);
      const balanceInEth = formatEther(balanceWei);

      const tokenRes = await alchemy.core.getTokenBalances(contract);

      const formatted = await formatTokens(tokenRes.tokenBalances);

      // Add ETH
      formatted.unshift({
        symbol: "ETH",
        name: "Ethereum",
        balance: Number(balanceInEth).toFixed(4),
      });

      setContractTokens(formatted);
    } catch (err) {
      console.error("Failed to fetch contract info:", err.message);
    }
  };

  return (
    <div className="flex flex-col gap-6 max-w-full mx-auto">
      <div className={`flex justify-center w-full flex-col ${walletAddress ? "" : "h-[calc(100vh_-_105px)]"}`}
>
        <div className="flex flex-col md:flex-row w-full gap-4 p-8">
          {contractAddress && (
            <ContractBalance
              address={contractAddress}
              balance={null}
              tokens={contractTokens}
              onRefresh={() => fetchContractInfo(contractAddress)}
              walletAddress={walletAddress}
            />
          )}
          {walletAddress && <BotWidget walletAddress={walletAddress} />}
          {/* {walletAddress && <TradingPair walletAddress={walletAddress} />} */}
          {walletAddress && (
            <WalletBalance
              address={walletAddress}
              balance={balance}
              tokens={tokens}
              onRefresh={() => fetchWalletInfo(walletAddress)}
            />
          )}
        </div>
        {/* <div className="flex flex-col md:flex-row w-full gap-4 p-4"> */}
          {/* <Swap walletAddress={walletAddress} onRefresh={() => fetchWalletInfo(walletAddress)}/> */}

          {/* {contractAddress && walletAddress && (
            <TransferOwnership
              address={contractAddress}
              walletAddress={walletAddress}
              onRefresh={() => fetchContractInfo(contractAddress)}
            />
          )} */}
        {/* </div> */}
        {/* {walletAddress && <BotWidget walletAddress={walletAddress} />} */}
        {/* <div className="flex gap-4 p-4">
            {walletAddress && <OrderWidget walletAddress={walletAddress} />}
          </div> */}
        <div className="flex gap-4 p-8 pt-0">
          {walletAddress && <TransactionWidget walletAddress={walletAddress} />}
        </div>
      </div>
    </div>
  );
};

export default Home;
